import React from 'react';
import { Button } from "@/components/ui/Button";
import { ArrowRight, Leaf, TreePine, Globe } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 text-white md:h-full">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20 md:bg-fixed" 
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=2169&auto=format&fit=crop')",
          filter: 'brightness(0.7) contrast(1.2)'
        }}
      />
      
      <div className="absolute inset-0 bg-[url('/images/forest-pattern.svg')] opacity-10" />
      
      <div className="container mx-auto px-4 py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Un Impact <span className="text-transparent bg-clip-text bg-gradient-to-r from-orcsys-400 to-orcsys-500">Positif</span> sur Notre Planète
          </h1>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Chez Orcsys, chaque projet numérique contribue à la préservation de notre environnement. 
            Nous transformons l'empreinte carbone en forêts durables.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-green-500 hover:bg-green-600 text-white" onClick={() => window.location.href = '#book'}>
              Démarrer un projet
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button size="lg" variant="outline" className="text-white border-white hover:bg-white/10" onClick={() => window.location.href = '#carbon-calculator'}>
              Calculer votre empreinte
            </Button>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-green-500/10 p-3 rounded-lg w-fit mb-4">
              <TreePine className="h-6 w-6 text-green-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Arbres Plantés</h3>
            <p className="text-3xl font-bold text-green-400 mb-2">90+</p>
            <p className="text-slate-300">
              Nombre moyen d'arbres plantés par projet pour compenser son empreinte carbone
            </p>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-green-500/10 p-3 rounded-lg w-fit mb-4">
              <Leaf className="h-6 w-6 text-green-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">CO2 Compensé</h3>
            <p className="text-3xl font-bold text-green-400 mb-2">12.5 tonnes</p>
            <p className="text-slate-300">
              Quantité moyenne de CO2 compensée par projet grâce à la plantation d'arbres
            </p>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-green-500/10 p-3 rounded-lg w-fit mb-4">
              <Globe className="h-6 w-6 text-green-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Zones de Reforestation</h3>
            <p className="text-3xl font-bold text-green-400 mb-2">4</p>
            <p className="text-slate-300">
              Continents où nous plantons des arbres pour maximiser l'impact environnemental
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
